import {Component, Input, OnInit} from '@angular/core';
import {finalize, first, take} from 'rxjs/operators';
import {ICreateOrderRequest, IPayPalConfig, NgxPayPalModule} from 'ngx-paypal';
import {UserService} from '../../../../../services/user-services/user.service';
import {formatDate, NgIf} from '@angular/common';
import {ProcessService} from '../../../../../services/user-services/process.service';
import {Router} from '@angular/router';
import {GlobalConstantsComponent} from '../../../../global-constants/global-constants.component';
import {DocumentsSharedService} from '../../../../../services/documents-shared.service';
import {ProcessSharedService} from '../../../../../services/process-shared.service';
import {HubspotService} from "../../../../../services/hubspot.service";
import {LocalSettingsService} from "../../../../../services/local-settings.service";
import {HelperService} from "../../../../../services/helper.service";

@Component({
    selector: 'app-paypal-button',
    templateUrl: './paypal-button.component.html',
    styleUrls: ['./paypal-button.component.scss'],
    standalone: true,
  imports: [NgxPayPalModule, NgIf]
})
export class PaypalButtonComponent implements OnInit {
    showSuccess: boolean;
    showCancel: boolean;
    showError: boolean;
    public isLoading: boolean = false;
    details: any;

    constructor(
        private userService: UserService,
        private processService: ProcessService,
        private router: Router,
        private documentService: DocumentsSharedService,
        private sharedProcessService: ProcessSharedService,
        private hubspotService: HubspotService,
        private helperService: HelperService,

    ) { }
    public payPalConfig ? : IPayPalConfig;
    @Input() public amount:any;
    @Input() public itemName:any;
    @Input() public booking:any;
    @Input() public process:any;
    @Input() public room:any;
    @Input() public promoCode:any;
    @Input() public pdfKey:any;
    @Input() public nextUrl:any;

    payPalId = GlobalConstantsComponent.payPalId;
    ngOnInit(): void {
        this.initConfig();
    }

    private initConfig(): void {
        this.payPalConfig = {
            currency: 'EUR',
            clientId: this.payPalId,
            createOrderOnClient: () => < ICreateOrderRequest > {
                purchase_units: [{
                    amount: {
                        currency_code: 'EUR',
                        value: this.amount,
                        breakdown: {
                            item_total: {
                                currency_code: 'EUR',
                                value:  this.amount,
                            }
                        }
                    },
                    items: [{
                        name: this.itemName,
                        quantity: '1',
                        category: 'DIGITAL_GOODS',
                        unit_amount: {
                            currency_code: 'EUR',
                            value:  this.amount,
                        },
                    }]
                }]
            },
            style: {
                label: 'paypal',
                layout: 'horizontal',
                tagline : false
            },
            onApprove: (data, actions) => {
                actions.order.get().then(details => {
                    this.details = details;
                    this.userService.createPaymentLog('Paypal','','Approuved transaction',details).subscribe();
                  });
            },
            onClientAuthorization: (data) => {
              if(this.itemName == "ACCOMMODATION"){
                this.payBooking(this.details.id);
              } else {
                this.pay(this.details.id, this.details.status);
              }
                this.userService.createPaymentLog('Paypal','','Authorized transaction',data).subscribe();
                this.showSuccess = true;
            },
            onCancel: (data, actions) => {
              this.userService.createPaymentLog('Paypal','','Cancelled transaction',data).subscribe();
              this.showCancel = true;
            },
            onError: err => {
              this.userService.createPaymentLog('Paypal','','Error on transaction',err).subscribe();
              this.showError = true;
                this.hubspotService.updateHubspot({
                  failed_payment_api: err.message,
                  methode_de_paiement: 'Paypal'
                }).subscribe();
            },
            onClick: (data, actions) => {
                //this.resetStatus();
            }
        };
    }

    public payBooking(paymentId) {
      this.isLoading = true;
      const keys = ['waiting_room', 'waiting_monthRent', 'waiting_start_date', 'waiting_end_date'];
      this.userService.deleteInformationsKey(keys).pipe(first()).subscribe();

      const endDate = new Date(this.booking.endDate);
      const startDate = new Date(this.booking.startDate);
      this.booking.endDate = formatDate(this.booking.endDate, 'yyyy-MM-dd', 'en-US');
      this.booking.hubspotEndDate = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
      this.booking.startDate = formatDate(this.booking.startDate, 'yyyy-MM-dd', 'en-US');
      this.booking.hubspotStartDate = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

      this.hubspotService.updateHubspot({
        stay_duration: this.monthDiff(startDate, endDate)
      }).subscribe();

      if (this.process) {
        this.sharedProcessService.updateProcessState('PAYED', this.process).subscribe();
      }
      const pricepromo = this.booking.reservation_fees - this.amount;

      this.userService.getCityById(this.room.property_address.city_group).subscribe((data: any) => {
        let hubDatas = {
          promo_code: this.promoCode,
          promo_code_amount: pricepromo > 0 ? pricepromo : null,
          amount: this.amount.toFixed(2),
          city: data.name,
          property_link: this.room.link,
          campagne: '',
          source: '',
          medium: ''
        };

        hubDatas = this.helperService.setUtmToHubspot(hubDatas);
        this.userService.setHubspotDeal(3321704, 11339149, hubDatas).subscribe();
      });

      const payment = {id: paymentId};
        this.processService.saveBooking({
            property: this.room,
            booking: this.booking,
            amount: this.amount.toFixed(2),
            promo_code: this.promoCode,
            transaction_mode: 'paypal',
            payment: payment,
            mailPayment: this.details ? this.details.payer.email_address : null
        }).subscribe(() => {
          this.booking.careStatus = 'pending';
          this.isLoading = false;
          this.processService.navigateWithDatas('Ok', 'snack-success', 'accommodation/pending');
        });
    }

    pay(paymentId, paymentStatus) {
      this.isLoading = true;
      const payment = {id : paymentId, status: paymentStatus};
      this.userService.createPayout({
        service: this.itemName,
        amount: this.amount.toFixed(2),
        payment: payment,
        transaction_mode: 'paypal',
        mailPayment: this.details ? this.details.payer.email_address : null
      }).subscribe(
        (data: any) => {
          if (this.pdfKey) {
            this.documentService.genPdf(this.pdfKey)
              .pipe(
                take(1),
                finalize(() => {
                  this.router.navigate([this.nextUrl]);
                  this.isLoading = false;

                })
              )
              .subscribe();
          } else {
            this.isLoading = false;
            this.router.navigate([this.nextUrl]);
          }
        }
      );
    }

  public monthDiff(startDate, endDate) {
    var months;
    months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += endDate.getMonth();
    return months <= 0 ? 0 : months;
  }
}
